import React, { useEffect, useRef, useState } from "react";
import { cn } from "../lib/helpers";

import * as styles from "./contactForm.module.css";

const WEB3FORMS_ENDPOINT = "https://api.web3forms.com/submit";
// Web3Forms access keys are public by design, the key only decides which inbox gets the message.
const WEB3FORMS_ACCESS_KEY = "2d8612e6-fa2d-4d2b-943e-8d761d3523df";
const SUCCESS_MESSAGE_TIMEOUT = 5000;

const STATUS = {
  idle: "idle",
  sending: "sending",
  success: "success",
  error: "error",
};

const STATUS_MESSAGES = {
  [STATUS.idle]: "",
  [STATUS.sending]: "Odesílání...",
  [STATUS.success]: "Vaše zpráva byla úspěšně odeslána, naše recepční se Vám ozve.",
  [STATUS.error]: "Při odesílání nastala chyba, zkuste to prosím později.",
};

async function sendToWeb3Forms(data) {
  const response = await fetch(WEB3FORMS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  });
  const result = await response.json();

  if (!response.ok || !result.success) {
    throw new Error(result.message || `Web3Forms request failed with ${response.status}`);
  }
}

export default function ContactForm({ action = "" }) {
  const [status, setStatus] = useState(STATUS.idle);
  const resetTimeout = useRef(null);

  useEffect(() => () => clearTimeout(resetTimeout.current), []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = Object.fromEntries(new FormData(form));

    clearTimeout(resetTimeout.current);
    setStatus(STATUS.sending);

    try {
      await sendToWeb3Forms({ ...data, subject: `Konzultace BBClinic - ${data.name}` });
      form.reset();
      setStatus(STATUS.success);
      resetTimeout.current = setTimeout(() => setStatus(STATUS.idle), SUCCESS_MESSAGE_TIMEOUT);
    } catch (error) {
      console.error(error);
      setStatus(STATUS.error);
    }
  };

  const isSending = status === STATUS.sending;

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <input type="hidden" name="access_key" value={WEB3FORMS_ACCESS_KEY} />
      <input type="hidden" name="from_name" value="BBClinic web" />
      {action && <input type="hidden" name="Služba" value={action} />}
      {/* Honeypot, real users never see or tick it. */}
      <input
        type="checkbox"
        name="botcheck"
        className={styles.honeypot}
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
      />

      <label htmlFor="contact-name" className={styles.srOnly}>
        Jméno
      </label>
      <input
        className={styles.input}
        id="contact-name"
        type="text"
        name="name"
        autoComplete="name"
        placeholder="Jméno *"
        required
      />

      <label htmlFor="contact-email" className={styles.srOnly}>
        E-mail
      </label>
      <input
        className={styles.input}
        id="contact-email"
        type="email"
        name="email"
        autoComplete="email"
        placeholder="E-mail *"
        required
      />

      <label htmlFor="contact-phone" className={styles.srOnly}>
        Telefon
      </label>
      <input
        className={styles.input}
        id="contact-phone"
        type="tel"
        name="Telefon"
        autoComplete="tel"
        placeholder="Telefon *"
        required
      />

      <label htmlFor="contact-message" className={styles.srOnly}>
        Vaše zpráva pro nás
      </label>
      <textarea
        className={styles.message}
        id="contact-message"
        name="Zpráva"
        placeholder="Vaše zpráva pro nás"
      />

      <button className={styles.button} type="submit" disabled={isSending}>
        Odeslat
      </button>

      <p
        className={cn(styles.info, status === STATUS.error && styles.infoError)}
        role="status"
        aria-live="polite"
      >
        {STATUS_MESSAGES[status]}
      </p>
    </form>
  );
}
